import {
  DELAY_UNIT_DAYS,
  DELAY_UNIT_HOURS,
} from '../ResponseSettingsForm/ResponseSettingsForm.constants';

export const DELAY_UNIT_OPTIONS = [
  // { key: DELAY_UNIT_MINUTES, text: 'Minutes', value: DELAY_UNIT_MINUTES },
  { key: DELAY_UNIT_HOURS, text: 'Hours', value: DELAY_UNIT_HOURS },
  { key: DELAY_UNIT_DAYS, text: 'Days', value: DELAY_UNIT_DAYS },
];

export const DEFAULT_DELAY_UNIT = DELAY_UNIT_DAYS;
export const DEFAULT_DELAY_QUANTITY = 1;
